/**
 * @see mockMd/union_city_war_goto.md
 */
import type {UnionCityWarGotoData} from '../types'

export const UnionCityWarGotoMock: UnionCityWarGotoData = {
  err_msg: '',
  room_id: 123456789,
  scheme: 'hiya://openRoom?room_id=123456789&from=union_city_war',
}
